import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { httpService } from "../../../../services/httpService.service";
import { siteVisitStatusEnum } from "../../../../services/Enums/siteVisitStatusEnum";
import { muted } from "../homeTheme";

// Each stage links to the board where visits of that stage actually live, so
// clicking "Data collection" or "Visit completed" opens the right page instead
// of always landing on the planning visits board.
const STAGE_ROUTE = {
  2: "/project/planning?visits", // Pre-planning
  3: "/project/planning?visits", // Planning
  4: "/project/implementation?trackingInprogress", // Data collection
  5: "/project/reporting?DataChecks", // Post data collection / Data check
  6: "/project/completed?ReportingList", // Visit completed
};

// PM/Admin overview: count of site visits in each stage.
const VisitsByStagePanel = () => {
  const navigate = useNavigate();
  const projectID = localStorage.getItem("currentProjectID");
  const [counts, setCounts] = useState({});
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectID) {
      setLoading(false);
      return;
    }
    // Must pass SiteVisitStatus for every stage (same as the dashboard's Site
    // Visit Summary) — otherwise the endpoint returns each visit's raw planning
    // status and everything collapses into pre-planning. This makes the stage
    // counts (data collection, completed, …) match the dashboard.
    const statusParams = [2, 3, 4, 5, 6]
      .map((s) => `SiteVisitStatus=${s}`)
      .join("&");
    httpService.get(
      `/api/Site/getAllSiteVisits?ProjectId=${projectID}&IgnorePagination=true&${statusParams}`,
      (res) => {
        const tally = {};
        (res?.data || []).forEach((v) => {
          const key = v?.siteVisitStatus ?? "default";
          tally[key] = (tally[key] || 0) + 1;
        });
        setCounts(tally);
        setTotal((res?.data || []).length);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [projectID]);

  if (loading) {
    return (
      <div className="homePanel">
        <div className="homePanelLoading">
          <Spin />
        </div>
      </div>
    );
  }

  const stageKeys = Object.keys(siteVisitStatusEnum).filter((k) => k !== "default");

  return (
    <div className="homePanel">
      <div className="homePanelHead">
        <h3>Visit progress by stage</h3>
        <span className="homePanelCount">{total} visits</span>
      </div>
      <div className="homeStageGrid">
        {stageKeys.map((key) => {
          const stage = siteVisitStatusEnum[key];
          return (
            <div
              className="homeStageCell"
              key={key}
              onClick={() =>
                navigate(STAGE_ROUTE[key] || "/project/planning?visits")
              }
            >
              <span className="homeStageCount">{counts[key] || 0}</span>
              <span className="homeStageLabel">
                <span
                  className="homeDot"
                  style={{ background: muted(stage.fill) }}
                />
                {stage.text}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VisitsByStagePanel;
